import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill-rule=\"evenodd\" d=\"M8 1.667a6.333 6.333 0 1 1 0 12.666A6.333 6.333 0 0 1 8 1.667\" clip-rule=\"evenodd\"></path><path d=\"M8 7.334v4\"></path><path fill-rule=\"evenodd\" d=\"M8.666 4.667a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0\" clip-rule=\"evenodd\"></path><path d=\"M8.666 4.667a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0\"></path><path fill-rule=\"evenodd\" d=\"M8 1.667a6.333 6.333 0 1 1 0 12.666A6.333 6.333 0 0 1 8 1.667\" clip-rule=\"evenodd\"></path><path d=\"M8 7.334v4\"></path>", 6)
  ]))]))
}
export default { render: render }